import React from 'react';
import { ArticleTextStandardImage } from '@components/ArticleImage/ArticleTextStandardImage';
import { BlockContentContext } from '../../BlockContent.utils';
import { Image, ImageSerializerProps } from '../components/Image/Image';

export const ImageSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value: { image, captionMode } }: ImageSerializerProps) => (
      <ArticleTextStandardImage image={image} captionMode={captionMode} />
    );
  }
  return ({ value }: ImageSerializerProps) => <Image value={value} />;
};
